import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    question: 'Erstellen Sie Webseiten für Unternehmen in Freiburg?',
    answer:
      'Ja, absolut! Ich erstelle professionelle Webseiten für Unternehmen in Freiburg im Breisgau und der gesamten Region – von Freiburg-Mitte bis Freiburg-Wiehre, Stühlinger, Haslach und Umgebung. Als Webdesigner aus dem nahen Schwarzwald kenne ich den Freiburger Markt sehr gut.',
  },
  {
    question: 'Was kostet Webdesign in Freiburg bei Ihnen?',
    answer:
      'Mein Komplettpaket für Webdesign in Freiburg kostet einmalig 899 €. Darin enthalten sind bis zu 7 Seiten, Responsive Design, SEO-Optimierung für Freiburg, Kontaktformular, SSL-Zertifikat, DSGVO-Absicherung und 2 kostenlose Änderungen. Keine versteckten Kosten.',
  },
  {
    question: 'Wie lange dauert die Erstellung einer Webseite für Freiburg?',
    answer:
      'Ihre Webseite ist in maximal 1 Woche fertig – deutlich schneller als die meisten Freiburger Agenturen, die oft 4–12 Wochen benötigen. Durch meinen effizienten Prozess mit AI-Unterstützung liefere ich schnell und in höchster Qualität.',
  },
  {
    question: 'Bieten Sie auch lokale SEO für Freiburg an?',
    answer:
      'Ja! Lokale SEO-Optimierung für Freiburg ist in jedem Paket enthalten. Ich optimiere Ihre Webseite gezielt für Suchanfragen wie "Webdesign Freiburg", "Handwerker Freiburg" oder "[Ihre Branche] Freiburg", damit Sie bei Google in Freiburg gefunden werden.',
  },
  {
    question: 'Kommen Sie auch persönlich nach Freiburg?',
    answer:
      'Ich bin in Titisee-Neustadt ansässig, nur ca. 30 km von Freiburg entfernt. Persönliche Treffen in Freiburg sind auf Wunsch möglich. Die meiste Zusammenarbeit läuft jedoch sehr effizient per Telefon, E-Mail und Video-Call ab.',
  },
  {
    question: 'Kann ich einen AI-Chatbot für mein Freiburger Unternehmen bekommen?',
    answer:
      'Ja! AI-Chatbots sind eine meiner Kernleistungen. Der Chatbot beantwortet Kundenanfragen aus Freiburg rund um die Uhr, bucht Termine automatisch und generiert Leads – auch wenn Sie gerade nicht erreichbar sind.',
  },
];

export default function FreiburgFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 sm:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="inline-block bg-brand-green/10 text-brand-green text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            FAQ
          </span>
          <h2 className="text-4xl md:text-5xl font-caprasimo text-brand-black mb-4">
            Häufige Fragen zu Webdesign Freiburg
          </h2>
          <p className="text-lg text-brand-grey max-w-2xl mx-auto">
            Alles, was Freiburger Unternehmen über meine Leistungen wissen möchten.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              className={`rounded-xl overflow-hidden border-2 transition-all ${
                openIndex === index
                  ? 'border-brand-green shadow-lg bg-white'
                  : 'border-brand-beige bg-brand-beige-light/50'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-brand-beige-light/60 transition-colors cursor-pointer min-h-[44px]"
              >
                <span
                  className={`text-base font-semibold pr-6 transition-colors ${
                    openIndex === index ? 'text-brand-green' : 'text-brand-black'
                  }`}
                >
                  {faq.question}
                </span>
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                    openIndex === index ? 'bg-brand-green rotate-180' : 'bg-white border border-brand-beige'
                  }`}
                >
                  <i
                    className={`ri-arrow-down-s-line text-xl ${
                      openIndex === index ? 'text-white' : 'text-brand-green'
                    }`}
                  />
                </div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5 text-brand-grey text-sm leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
